import { ReleaseAlertManager } from "./ReleaseAlertManager";
export default ReleaseAlertManager;
export * from "./ReleaseAlertManager";
